import { createStore } from 'effector'

import { logInFx } from './event'

export const $isPending = createStore(false)
  .on(logInFx.pending, (_, pending) => pending)
